module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_header_check-c25a8607d73fb60f85e9820dac6de0bb.svg";